import { render, staticRenderFns } from "./list.invite.vue?vue&type=template&id=e2966caa&"
import script from "./list.invite.vue?vue&type=script&lang=js&"
export * from "./list.invite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports